module.exports = __webpack_public_path__ + "img/cat-pic.4f5818e6.png";